module.exports = __webpack_public_path__ + "img/0.00b27770.png";